import { ConsolePage, Icon, StatusBadge, QueryState, CardGridSkeleton } from '@/components';
import { useCourses } from '@/hooks/queries';
import { useLocalized } from '@/hooks/useLocalized';

export function InstructorCourses() {
  const { L } = useLocalized();
  const coursesQuery = useCourses();
  const mine = coursesQuery.data ?? [];

  return (
    <ConsolePage title="My courses" th="คอร์สของฉัน" crumbs="TEACHING">
      <QueryState query={coursesQuery} skeleton={<CardGridSkeleton count={3} cols={3} />} isEmpty={() => mine.length === 0} emptyIcon="book" emptyTitle="No courses yet">
        {() => (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 16 }}>
            {mine.map((c) => (
          <div key={c.id} className="card" style={{ overflow: 'hidden' }}>
            <div style={{ aspectRatio: '3 / 1', background: c.coverUrl ? `${c.cover} center/cover no-repeat url("${c.coverUrl}")` : c.cover, position: 'relative' }}>
              {!c.coverUrl && <div style={{ position: 'absolute', inset: 0, background: 'repeating-linear-gradient(135deg, rgba(255,255,255,.16), rgba(255,255,255,.16) 1px, transparent 1px, transparent 9px)' }} />}
              <div style={{ position: 'absolute', top: 12, right: 12 }}><StatusBadge status={c.status} /></div>
            </div>
            <div style={{ padding: 16 }}>
              <div className="th" style={{ fontSize: 15.5, fontWeight: 600 }}>{L(c.title)}</div>
              <div style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 14 }}>{c.title.en} · {c.code}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <span style={{ display: 'flex', gap: 6, alignItems: 'center', color: 'var(--ink-2)' }}><Icon name="users" size={15} /> {c.enrolled} enrolled</span>
                <span style={{ display: 'flex', gap: 6, alignItems: 'center', color: 'var(--ink-2)' }}><Icon name="clock" size={15} /> {c.hours}h</span>
              </div>
            </div>
          </div>
            ))}
          </div>
        )}
      </QueryState>
    </ConsolePage>
  );
}
